import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from '../../styles/styles.css';

import type { ISpinnerDeps, TSpinner } from './models';
import spinnerStyles from './styles/spinner.css';
import { Spinner as Component } from './spinner';

export const Spinner = createWidget<ISpinnerDeps, TSpinner>({
    styles: { ...styles, ...spinnerStyles },
})(Component);
